module.exports = __webpack_public_path__ + "static/media/bilal.0305077d.jpg";